import styled from "styled-components";

export const UploadContainer = styled.div`
  padding: 2rem 0;
  position: relative;
  text-align: center;
`;

export const UploadTitle = styled.h6`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2e186a;
`;

export const UploadDescription = styled.p`
  margin-bottom: 2rem;
  color: #7a7a7a;
  font-size: 1.1rem;
`;

export const UploadArea = styled.div<{ isDragging: boolean }>`
  border: 2px dashed ${(props) => (props.isDragging ? "#2e186a" : "#cccccc")};
  border-radius: 10px;
  padding: 3rem;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => (props.isDragging ? "rgba(46, 24, 106, 0.05)" : "transparent")};
  cursor: pointer;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7a7a7a;

  &:hover {
    border-color: #2e186a;
    background-color: rgba(46, 24, 106, 0.05);
  }

  svg {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #2e186a;
  }

  p {
    margin-bottom: 0;
  }
`;

// Other styles remain unchanged
export const FileInput = styled.input`
  display: none;
`;

export const FileList = styled.div`
  margin: 1.5rem 0;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 0.5rem;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  span:first-child {
    flex: 1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 10px;
  }

  span:nth-child(2) {
    color: #7a7a7a;
    margin: 0 1rem;
  }

  button {
    background: none;
    border: none;
    color: #ff5252;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    border-radius: 50%;
    
    &:hover {
      background-color: rgba(255, 82, 82, 0.1);
    }
  }
`;

export const UploadButton = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
`;